import Box from '@mui/material/Box';
import Grid from '@mui/material/Grid';
import Container from '@mui/material/Container';
import Typography from '../components/Typography';import theme from "../../theme";
import LinkIcon from '@mui/icons-material/Link';
import Stack from '@mui/material/Stack';

export function ProductDemo() {

    return (
        <Container className={"ContactComponent"} component="section" sx={{pt: 10, mb: 10, display: 'flex'}}>
            <Grid container>
                <Grid item xs={12} md={6} sx={{zIndex: 1}}>
                    <Box
                        sx={{
                            display: 'flex',
                            justifyContent: 'center',
                            bgcolor: theme.palette.secondary.main,
                            py: 8,
                            px: 3,
                        }}
                    >
                        <Box component="form" sx={{maxWidth: 400, color: theme.palette.secondary.light}}>
                            <Typography variant="h2" component="h2" sx={{ color: theme.palette.secondary.light }} gutterBottom>
                                Contact us
                            </Typography>

                            <Stack direction="row" spacing={1} sx={{maxWidth: 400, color: theme.palette.secondary.light}}>
                                <LinkIcon/>
                                <a href={"https://www.govsky.com/demo"} sx={{ color: theme.palette.secondary.light }}><Typography variant="h5" sx={{ color: theme.palette.secondary.light }}>Book a demo with GovSky today.</Typography></a>
                            </Stack>
                        </Box>
                    </Box>
                </Grid>
                <Grid
                    item
                    xs={12}
                    md={6}
                    sx={{display: {md: 'block', xs: 'none'}, position: 'relative'}}
                >
                    <Box
                        sx={{
                            position: 'absolute',
                            top: -67,
                            left: -67,
                            right: 0,
                            bottom: 0,
                            width: '100%',
                            background: 'url(/img/productCTAImageDots.png)',
                        }}
                    />
                    <Box
                        component="img"
                        src='/img/industrial_steel_750.jpg'
                        alt="image decoration for email updates"
                        sx={{
                            position: 'absolute',
                            top: -28,
                            left: -28,
                            right: 0,
                            bottom: 0,
                            width: '100%',
                            maxWidth: 600,
                        }}
                    />
                </Grid>
            </Grid>
        </Container>
    );
}

export default ProductDemo;
